
class FooterSiteMap
  constructor: ->
    @init()

  init: ->
    $footerSitemap = $('.footer_sitemap')
    @$footerSitemapTitle = $footerSitemap.find('.category_title')
    @$footerSitemapItem = $footerSitemap.find('.sitemap_category')
    @$footerSitemapItemHasSubNav = $footerSitemap.find('.sitemap_item.hasSubNav')
    @$footerSitemapItemHasSubNavTitle = @$footerSitemapItemHasSubNav.find('.category_title')
    @$footerSitemapItemHasSubNavTitle.on 'click', @toggleSitemap

  toggleSitemap: (e)=>
    if $('body').hasClass('is-layout3')
      if $(e.target).hasClass('active')
        $(e.target).removeClass('active')
        $(e.target).next('.sitemap_category').stop().slideUp(200)
      else
        $(e.target).addClass('active')
        $(e.target).next('.sitemap_category').stop().slideDown(200)

  open: =>


  close: =>

module.exports = FooterSiteMap



// WEBPACK FOOTER //
// ./src/scripts/modules/FooterSiteMap.coffee